import {FC, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {HeaderWrapper} from '../../../_metronic/layout/components/header'
import {RightToolbar} from '../../../_metronic/partials/layout/RightToolbar'
import {ScrollTop} from '../../../_metronic/layout/components/scroll-top'
import {Content} from '../../../_metronic/layout/components/content'
import {FooterWrapper} from '../../../_metronic/layout/components/footer'
import {Sidebar} from '../../../_metronic/layout/components/sidebar'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../../../_metronic/partials'
import {PageDataProvider} from '../../../_metronic/layout/core'
import {reInitMenu} from '../../../_metronic/helpers'
import {ToolbarWrapper} from '../../../_metronic/layout/components/toolbar'
import {PlatformsPage} from './PlatformsPage'

const PlatformsLayout: FC = () => {
  const location = useLocation()
  
  useEffect(() => {
    reInitMenu()
  }, [location.key])
  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <div
                    id='kt_app_content'
                    className='app-content flex-column-fluid'
                  >
                    <div
                      id='kt_app_content_container'
                      className='app-container container-xxl'
                    >
                      <PlatformsPage />
                    </div>
                  </div>
                </Content>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>
        <RightToolbar />
        <ScrollTop />
        <ActivityDrawer />
        <DrawerMessenger />
        <InviteUsers />
        <UpgradePlan />
      </div>
    </PageDataProvider>
  )
}

export {PlatformsLayout}

